import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StoreService, CityService, StoreTypeService, StoreGetOneDto } from 'src/generated_client'
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { ComponentRestrictions } from 'ngx-google-places-autocomplete/objects/options/componentRestrictions';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';

@Component({
  selector: 'app-new-shop',
  templateUrl: './add-shop.component.html',
  styleUrls: ['./add-shop.component.css']
})

export class AddShopComponent implements OnInit {

  id: any;
  isEdit: boolean = false;
  title: string = "";
  allStoreTypes: StoreType[] = [];
  allCities: City[] = [];
  namePattern = "^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$"

  public options: Options = new Options();

  ShopForm: FormGroup = this.fb.group({
    id: [''],
    name: ['', Validators.compose([Validators.pattern(this.namePattern), Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    email: ['', Validators.compose([Validators.email, Validators.required])],
    phone: ['', Validators.required],
    storeType: ['', Validators.required],
    code: ['', Validators.compose([Validators.required, Validators.pattern("^[a-z0-9]{3}$")])],
    city: ['', Validators.required],
    address: ['', Validators.required],
    image: ['', Validators.required],
    logo: ['', Validators.required],
    dsImage: [''],
    dsLogo: [''],
    commission: [''],
    open1: ['', Validators.required],
    close1: ['', Validators.required],
    open2: [''],
    close2: [''],
    deliveryTime: ['', Validators.required],
    price: ['', Validators.required],
    tokenMP: ['', Validators.required],
    publicKeyMP: ['', Validators.required],
    deliveryValue: ['', Validators.required],
    maxDistance: ['', Validators.required],
    additionalImages: [''],
    location: [''],
    latitude: ['', Validators.required],
    longitude: ['', Validators.required],
    slogan: ['', Validators.required],
    additionalImg: [''],
    itemImagesUrl: this.fb.array([]),
    password: [''],
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private service: StoreService,
    private snackBar: SnackBarService,
    private router: Router,
    private datePipe: DatePipe,
    private storeTypeService: StoreTypeService,
    private cityService: CityService,
  ) {
    this.options.componentRestrictions = new ComponentRestrictions();
    this.options.componentRestrictions.country = "AR";
  }

  ngOnInit(): void {

    this.id = this.activatedRoute.snapshot.paramMap.get("id");

    if (this.id != null) {

      this.isEdit = true;
    }

    this.changeTitle();

    this.cityService.apiCityGetAllCitiesGet().subscribe(c => {
      c.forEach(x => {
        let city: City;
        city = {
          id: Number(x.cdCity),
          name: String(x.dsName)
        };
        this.allCities.push(city);
      });
    });

    this.storeTypeService.apiStoreTypeGetGet().subscribe(s => {
      s.forEach(x => {
        let storeType: StoreType;
        storeType = {
          id: Number(x.cdStoreType),
          name: String(x.dsName)
        };

        this.allStoreTypes.push(storeType);
      });
    });

    if (this.isEdit) {

      this.ChangeEditValidator();

      this.service.apiStoreGetOneStoreGet(this.id).subscribe(x => {
        this.SetControls(x);
      },
        error => {
          this.snackBar.openSnackBar(error.error.error, 'Aceptar');
        }
      );

    } else {
      this.ChangeAddValidator();
    }
  }

  private ChangeEditValidator() {
    this.ShopForm.controls['commission'].setValidators([Validators.required]);
    this.ShopForm.controls['commission'].updateValueAndValidity();
    this.ShopForm.controls['code'].disable();
    this.ShopForm.controls['image'].clearValidators();
    this.ShopForm.controls['logo'].clearValidators();
  }

  private ChangeAddValidator() {
    this.ShopForm.controls['commission'].clearValidators();
    this.ShopForm.controls['commission'].updateValueAndValidity();
    this.ShopForm.controls['password'].setValidators([Validators.required]);
  }

  private SetControls(x: StoreGetOneDto) {
    this.ShopForm.controls['id'].setValue(this.id);
    this.ShopForm.controls['name'].setValue(x.dsName);
    this.ShopForm.controls['email'].setValue(x.dsEmail);
    this.ShopForm.controls['phone'].setValue(x.dsPhone);
    this.ShopForm.controls['storeType'].setValue(x.cdStoreType);
    this.ShopForm.controls['city'].setValue(x.cdCity);
    this.ShopForm.controls['address'].setValue(x.dsAddress);
    this.ShopForm.controls['dsImage'].setValue(x.dsImg);
    this.ShopForm.controls['dsLogo'].setValue(x.dsLogo);
    this.ShopForm.controls['open1'].setValue(this.datePipe.transform(x.dtOpeningTime, 'shortTime'));
    this.ShopForm.controls['close1'].setValue(this.datePipe.transform(x.dtClosingTime, 'shortTime'));
    this.ShopForm.controls['open2'].setValue(this.datePipe.transform(x.dtOpeningTime2, 'shortTime'));
    this.ShopForm.controls['close2'].setValue(this.datePipe.transform(x.dtClosingTime2, 'shortTime'));
    this.ShopForm.controls['deliveryTime'].setValue(x.nmDeliveryTime);
    this.ShopForm.controls['price'].setValue(x.qtPersonCost);
    this.ShopForm.controls['tokenMP'].setValue(x.dsApiMeli);
    this.ShopForm.controls['publicKeyMP'].setValue(x.dsMeliPublicKey);
    this.ShopForm.controls['deliveryValue'].setValue(x.qtDeliveryValue);
    this.ShopForm.controls['maxDistance'].setValue(x.nmMaximumKmDelivery);
    this.ShopForm.controls['longitude'].setValue(x.qtLongitude);
    this.ShopForm.controls['latitude'].setValue(x.qtLatitude);
    this.ShopForm.controls['slogan'].setValue(x.dsSlogan);
    this.ShopForm.controls['commission'].setValue(x.qtAppCommission);

    x.storeImages?.forEach(x => {
      this.itemImagesUrl.push(new FormControl(x))
    })
  }

  changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR COMERCIO";
    } else {
      this.title = "AGREGAR NUEVO COMERCIO";
    }
  }

  saveChanges(form: any) {

    if (this.isEdit) {

      this.service.apiStoreEditStorePutForm(
        this.id,
        form.city,
        form.storeType,
        form.name.trim(),
        form.email,
        form.phone,
        form.address,
        undefined,
        undefined,
        form.image,
        form.password,
        form.open1,
        form.close1,
        undefined,
        undefined,
        form.deliveryTime,
        form.price,
        form.latitude,
        form.longitude,
        form.commission,
        undefined,
        form.logo,
        form.slogan,
        form.additionalImg,
        undefined,
        form.tokenMP,
        form.publicKeyMP,
        form.deliveryValue,
        form.maxDistance)
        .subscribe(response => {

          this.snackBar.openSnackBar('Los cambios fueron guardados con éxito.', 'Aceptar');
          this.router.navigate(['adm-comercio']);
        },
          error => {
            this.snackBar.openSnackBar(error.error.error, 'Aceptar');
          }
        );
    }
    else {
      console.log(form.image);
      console.log(form.logo);
      this.service.apiStoreNewStorePostForm(
        form.city,
        form.storeType,
        form.name,
        form.email,
        form.phone,
        form.address,
        undefined,
        undefined,
        form.image._files[0],
        form.password,
        form.open1,
        form.close1,
        undefined,
        undefined,
        form.deliveryTime,
        form.price,
        form.latitude,
        form.longitude,
        form.commission,
        form.slogan,
        undefined,
        form.logo._files[0],
        form.code,
        form.additionalImg._files,
        undefined,
        form.tokenMP,
        form.publicKeyMP,
        form.deliveryValue,
        form.maxDistance
      )
        .subscribe(x => {
          this.snackBar.openSnackBar('Comercio creado con éxito', 'Aceptar');
          this.router.navigate(['adm-comercio']);
        },
          error => {
            console.log(error);
            this.snackBar.openSnackBar(error.error.error, 'Aceptar');
          }
        );
    }
  }

  get DsImage() {
    return this.ShopForm.controls['dsImage'].value;
  }

  get DsLogo() {
    return this.ShopForm.controls['dsLogo'].value;
  }

  get itemImagesUrl() {
    return this.ShopForm.get("itemImagesUrl") as FormArray
  }

  get imagesUrl() {
    return this.itemImagesUrl.value
  }

  get ImageFlex(): number {
    return 100 / this.itemImagesUrl.length;
  }

  public handleAddressChange(address: Address) {
    this.ShopForm.controls['longitude'].setValue(address.geometry.location.lng());
    this.ShopForm.controls['latitude'].setValue(address.geometry.location.lat());
  }

}

interface StoreType {
  id: number;
  name: string;
}

interface City {
  id: number;
  name: string;
}
